import { z } from 'zod'

const jpgMediaSizesSchema = z.object({
  lg: z.object({
    jpg: z.string(),
    avif: z.string(),
    webp: z.string(),
  }),
  sm: z.object({
    jpg: z.string(),
    avif: z.string(),
    webp: z.string(),
  }),
})
const pngMediaSizesSchema = z.object({
  lg: z.object({
    png: z.string(),
    avif: z.string(),
    webp: z.string(),
  }),
  sm: z.object({
    png: z.string(),
    avif: z.string(),
    webp: z.string(),
  }),
})

const mediaSchema = z.object({
  bgLandscape: jpgMediaSizesSchema,
  bgPortrait: jpgMediaSizesSchema,
  picture: pngMediaSizesSchema,
})

const slideUrlsSchema = z.object({
  page: z.string().nullable(),
  game: z.string().nullable(),
  category: z.string().nullable(),
  url: z.string().nullable(),
})

const slideSchema = z
  .object({
    description: z.string().nullable().default(''),
    id: z.number(),
    media: mediaSchema,
    title: z.string().nullable().default(''),
    button: z.string().nullable().default(''),
    urls: slideUrlsSchema,
  })
  .transform((slide) => {
    if (slide.title?.includes('|') && slide.button === '') {
      const [title, buttonLabel] = slide.title.split('|')

      return {
        ...slide,
        title,
        button: buttonLabel,
      }
    }

    return slide
  })

export const slidesSchema = z.array(slideSchema)

export type Slide = z.infer<typeof slideSchema>
export type SlideMedia = z.infer<typeof mediaSchema>
